import React from 'react'
// libs
import { InteractionStatus } from '@azure/msal-browser'
import { useMsal } from '@azure/msal-react'
// hooks
import { useMicrosoftLogin } from 'hooks/useMicrosoftLogin'
// layouts
import AuthLayout from 'layouts/AuthLayout'
// components
import AuthCompanySelectModal from 'components/Modals/AuthCompanySelectModal'

const AzureSsoPage = () => {
  const { inProgress } = useMsal()
  const { microsoftSignIn } = useMicrosoftLogin()

  React.useEffect(() => {
    if (inProgress !== InteractionStatus.None) {
      return
    }

    microsoftSignIn()
  }, [inProgress])

  return (
    <AuthLayout>
      <AuthCompanySelectModal />
    </AuthLayout>
  )
}
export default AzureSsoPage
